import CardProject from '../../components/items/CardProject'

import readmeGenerator from '../../img/projects/readmeGenerator.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project8() {
  return (
    <div>
      <CardProject
        name="Readme Generator"
        img={readmeGenerator}
        text="O projeto Readme Generator é uma aplicação web desenvolvida para automatizar a criação de arquivos README padronizados e estilizados para projetos de software. Com foco na produtividade e padronização, a ferramenta facilita a geração de documentações completas, garantindo que cada projeto possua uma descrição clara, organizada e atrativa. A aplicação foi construída utilizando a biblioteca React, proporcionando uma interface moderna e intuitiva, que permite ao usuário criar e personalizar seus README files com facilidade. Além disso, o projeto faz uso de styled-components, permitindo a criação de estilos customizados diretamente nos componentes React, garantindo consistência visual em cada README gerado. Entre as funcionalidades principais estão a possibilidade de definir seções específicas como descrição do projeto, tecnologias utilizadas, instruções de instalação, uso, e muito mais. O Readme Generator também inclui ícones estilizados, graças à integração com a biblioteca react-icons, oferecendo um toque visual diferenciado aos arquivos README. O Readme Generator não só simplifica o processo de documentação para os desenvolvedores, como também promove uma padronização essencial para a organização de projetos de software."
        app="https://readme-generator-cyan.vercel.app/"
        repo="https://github.com/RiccettoDev/readme-generator"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
